import { render, staticRenderFns } from "./x-button-switch.vue?vue&type=template&id=ffa1f74c&scoped=true&"
import script from "./x-button-switch.vue?vue&type=script&lang=js&"
export * from "./x-button-switch.vue?vue&type=script&lang=js&"
import style0 from "./x-button-switch.vue?vue&type=style&index=0&id=ffa1f74c&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa1f74c",
  null
  
)

export default component.exports